import constants from './../../utils/constants';
import api from '@/api';

const store = {
  state: {
    dataOrderReport: [],
    dataOrderItemNumber: [],
    outletInfo: [],
    pagingOrderReport: {
      page: 1,
      size: 20,
      total: 0
    },
    filteringOrderReport: {
      orderId: '',
      outletCode: '',
      orderType: '',
      orderStatus: [],
      createdAt: {
        startDate: '',
        endDate: ''
      },
      transferStatus: [],
      phoneNumber: '',
      cancelStatus: []
    },
    orderReportDetail: [],
    updateOrderStatus: {
      isUpdating: false,
      isSuccess: false,
      error: null
    },
    updateOrderDetail: {
      detail: {},
      isUpdating: false,
      isSuccess: false,
      error: null
    },
    cancelOrderStatus: {
      isCanceling: false,
      isSuccess: false,
      error: null
    },
    newOrderNumber: undefined,
    newHMDOrderNumber: undefined,
    isLoadingShow: false,
    isVoiceShow: true,
    activeOrderType: '',
    newOrderCounts: null,
    inProgressCount: 0,
    inProgressStatus: {
      orderId: '',
      outletCode: '',
      orderType: '',
      orderStatus: [],
      createdAt: {
        startDate: '',
        endDate: ''
      },
      transferStatus: [],
      phoneNumber: '',
      cancelStatus: []
    },
    isNewOrderComing: 0,
    searchMenu: []
  },

  mutations: {
    SET_ORDERREPORT: (state, payload) => {
      state.dataOrderReport = payload;
    },
    SET_ORDERNUMBER: (state, payload) => {
      state.dataOrderItemNumber = payload;
    },
    UPDATE_ORDER_DETAIL: (state, payload) => {
      state.dataOrderReport = state.dataOrderReport.map(orderReport => {
        if (orderReport.orderId === payload.orderId) {
          return {
            ...orderReport,
            ...payload
          };
        } else {
          return orderReport;
        }
      })
    },
    SET_ORDERREPORT_OUTLET_INFO: (state, payload) => {
      state.outletInfo = payload;
    },
    SET_PAGING_PAGE_ORDERREPORT: (state, payload) => {
      state.pagingOrderReport.page = payload;
    },
    SET_PAGING_TOTAL_ORDERREPORT: (state, payload) => {
      state.pagingOrderReport.total = payload;
    },
    SET_FILTERING_ORDERREPORT: (state, payload) => {
      state.filteringOrderReport = payload;
    },
    SET_INPROGRESS_STATUS: (state, payload) => {
      state.inProgressStatus.orderStatus = payload;
    },
    SET_INPROGRESS_ORDERTYPE: (state, payload) => {
      state.inProgressStatus.orderType = payload;
    },

    SET_ORDER_REPORT_DETAIL: (state, payload) => {
      state.orderReportDetail = payload;
    },
    SET_UPDATE_ORDER_STATUS: (state, payload) => {
      state.updateOrderStatus = payload;
    },
    SET_UPDATE_ORDER_STATUS_UPDATING: (state, payload) => {
      state.updateOrderStatus.isUpdating = payload;
    },
    SET_UPDATE_ORDER_STATUS_SUCCESS: (state, payload) => {
      state.updateOrderStatus.isSuccess = payload;
    },
    SET_UPDATE_ORDER_STATUS_ERROR: (state, payload) => {
      state.updateOrderStatus.error = payload;
    },
    SET_UPDATE_ORDER_DETAIL: (state, payload) => {
      state.updateOrderDetail = payload;
    },
    SET_UPDATE_ORDER_DETAIL_UPDATING: (state, payload) => {
      state.updateOrderDetail.isUpdating = payload;
    },
    SET_UPDATE_ORDER_DETAIL_RESULT: (state, payload) => {
      state.updateOrderDetail.detail = payload;
    },
    SET_UPDATE_ORDER_DETAIL_SUCCESS: (state, payload) => {
      state.updateOrderDetail.isSuccess = payload;
    },
    SET_UPDATE_ORDER_DETAIL_ERROR: (state, payload) => {
      state.updateOrderDetail.error = payload;
    },
    SET_CANCEL_ORDER_STATUS: (state, payload) => {
      state.cancelOrderStatus = payload;
    },
    SET_CANCEL_ORDER_STATUS_UPDATING: (state, payload) => {
      state.cancelOrderStatus.isCanceling = payload;
    },
    SET_CANCEL_ORDER_STATUS_SUCCESS: (state, payload) => {
      state.cancelOrderStatus.isSuccess = payload;
    },
    SET_CANCEL_ORDER_STATUS_ERROR: (state, payload) => {
      state.cancelOrderStatus.error = payload;
    },
    SET_NEW_ORDER_NUMBER: (state, payload) => {
      state.newOrderNumber = payload;
    },
    SET_NEW_HMD_ORDER_NUMBER: (state, payload) => {
      state.newHMDOrderNumber = payload;
    },
    SET_ISLOADINGSHOW: (state, payload) => {
      state.isLoadingShow = payload;
    },
    SET_ISVOICESHOW: state => {
      state.isVoiceShow = !state.isVoiceShow;
    },
    SET_ACTIVE_ORDERTYPE: (state, payload) => {
      state.activeOrderType = payload;
    },
    SET_NEW_ORDER_COUNTS: (state, payload) => {
      state.newOrderCounts = payload;
    },
    SET_SEARCH_MENU: (state, payload) => {
      state.searchMenu = payload;
    },
    SET_INPROGRESS_COUNT: (state, payload) => {
      state.inProgressCount = payload;
    },
    SET_NEWORDER_COMING: (state, payload) => {
      state.isNewOrderComing = state.isNewOrderComing + payload;
    }
  },

  getters: {
    FilteringOrderReport: state => state.filteringOrderReport,
    PagingOrderReport: state => state.pagingOrderReport,
    GetAllOrderReport: state => state.dataOrderReport,
    GetAllOrderReportOutletInfo: state => state.outletInfo,
    GetOneOrderReport: state => id =>
      state.dataOrderReport.find(dataOrderReport => dataOrderReport.id === id),
    GetOrderReportDetail: state => state.orderReportDetail,
    GetUpdateOrderStatus: state => state.updateOrderStatus,
    GetUpdateOrderDetail: state => state.updateOrderDetail,
    CancelOrderStatus: state => state.cancelOrderStatus,
    GetNewOrderNumber: state => state.newOrderNumber,
    GetNewHMDOrderNumber: state => state.newHMDOrderNumber,
    GetIsLoadingShow: state => state.isLoadingShow,
    GetIsVoiceShow: state => state.isVoiceShow,
    GetActiveOrderType: state => state.activeOrderType,
    GetAllOrderNumber: state => state.dataOrderItemNumber,
    GetAllNewOrderCounts: state => state.newOrderCounts,
    GetInProgressCount: state => state.inProgressCount,
    GetNewOrderComing: state => state.isNewOrderComing,
    GetSearchMenu: state => state.searchMenu
  },

  actions: {
    UpdateFilteringOrderReport({ commit }, payload) {
      commit('SET_FILTERING_ORDERREPORT', payload);
    },

    async GetAllOrderReport({ commit, state }) {
      try {
        commit('SET_ISLOADINGSHOW', true);
        const result = await api.GetAllOrderReport(
          state.pagingOrderReport,
          state.filteringOrderReport
        );
        commit('SET_PAGING_TOTAL_ORDERREPORT', result.headers['data-length']);
        commit('SET_ORDERREPORT', result.data.data);
        commit('SET_ORDERNUMBER', JSON.parse(result.headers['data-count']));
        commit('SET_ORDERREPORT_OUTLET_INFO', result.data.outlet_info);
        commit('SET_ISLOADINGSHOW', false);
        return result;
      } catch (e) {
        commit('SET_PAGING_TOTAL_ORDERREPORT', 0);
        commit('SET_ORDERREPORT', []);
        commit('SET_ORDERNUMBER', []);
        commit('SET_ORDERREPORT_OUTLET_INFO', []);
        commit('SET_ISLOADINGSHOW', false);
      }
    },

    async GetAllOrderInProgressCount({ commit, state }) {
      try {
        const result = await api.GetAllOrderReport(
          state.pagingOrderReport,
          state.inProgressStatus
        );
        commit(
          'SET_INPROGRESS_COUNT',
          JSON.parse(result.headers['data-count'])
        );
        return result;
      } catch (e) {
        throw e
      }
    },

    async GetOneOrderReportDetail({ commit, state }, payload) {
      try {
        commit('SET_ISLOADINGSHOW', true);
        const result = await api.GetOneOrderReportDetail(
          payload.id,
          payload.type
        );
        commit('SET_ISLOADINGSHOW', false);
        commit('SET_ORDER_REPORT_DETAIL', result.data.data);
      } catch (e) {
        commit('SET_ISLOADINGSHOW', false);
        throw e;
      }
    },

    async UpdateOrderStatus({ dispatch, commit }, payload) {
      commit('SET_UPDATE_ORDER_STATUS', {
        isUpdating: true,
        isSuccess: false,
        error: null
      });
      try {
        await api.UpdateOrderStatus(payload);
        commit('SET_UPDATE_ORDER_STATUS_UPDATING', false);
        commit('SET_UPDATE_ORDER_STATUS_SUCCESS', true);
      } catch (e) {
        commit('SET_UPDATE_ORDER_STATUS_UPDATING', false);
        commit('SET_UPDATE_ORDER_STATUS_ERROR', e.response.data.message);
      }
    },

    async UpdateOrderDetail({ dispatch, commit }, payload) {
      commit('SET_UPDATE_ORDER_DETAIL', {
        detail: {},
        isUpdating: true,
        isSuccess: false,
        error: null
      });
      try {
        const result = await api.UpdateOrderDetail({ ...payload, reason: 'test' });
        commit('SET_UPDATE_ORDER_DETAIL_UPDATING', false);
        commit('SET_UPDATE_ORDER_DETAIL_SUCCESS', true);
        commit('SET_UPDATE_ORDER_DETAIL_RESULT', result.data.data);
      } catch (e) {
        commit('SET_UPDATE_ORDER_DETAIL_UPDATING', false);
        commit('SET_UPDATE_ORDER_DETAIL_ERROR', e.response.data.message);
      }
    },

    async CancelOrder({ dispatch, commit, state }, payload) {
      commit('SET_CANCEL_ORDER_STATUS', {
        isCanceling: true,
        isSuccess: false,
        error: null
      });
      try {
        const response = await api.cancelOrder(payload);
        commit('SET_CANCEL_ORDER_STATUS_UPDATING', false);
        if (
          response.data.code === constants.STATUS_200_STRING &&
          response.data.invalidMessage === constants.UPPER_SUCCESS
        ) {
          commit('SET_CANCEL_ORDER_STATUS_SUCCESS', true);
        } else {
          commit('SET_CANCEL_ORDER_STATUS_ERROR', response.data.invalidMessage);
        }
      } catch (e) {
        commit('SET_CANCEL_ORDER_STATUS_UPDATING', false);
        commit('SET_CANCEL_ORDER_STATUS_ERROR', e.response.data.message);
      }
    },

    async RefundOrder({ dispatch, commit, state }, payload) {
      commit('SET_CANCEL_ORDER_STATUS', {
        isCanceling: true,
        isSuccess: false,
        error: null
      });
      try {
        const response = await api.refundOrder(payload);
        commit('SET_CANCEL_ORDER_STATUS_UPDATING', false);
        if (
          response.data.code === constants.STATUS_200_STRING &&
          response.data.invalidMessage === constants.UPPER_SUCCESS
        ) {
          commit('SET_CANCEL_ORDER_STATUS_SUCCESS', true);
        } else {
          commit('SET_CANCEL_ORDER_STATUS_ERROR', response.data.invalidMessage);
          // It should be re-fetched even if refund request fails, because its status may have changed
          dispatch('GetAllOrderReport');
        }
      } catch (e) {
        commit('SET_CANCEL_ORDER_STATUS_UPDATING', false);
        commit('SET_CANCEL_ORDER_STATUS_ERROR', e.response.data.message);
      }
    },

    async GetNewOrder({ commit }, payload) {
      try {
        const { data } = await api.GetNewOrder(payload);
        commit('SET_NEW_ORDER_COUNTS', data.result);
        return data;
      } catch (e) {
        return e.response;
      }
    },

    async SearchMenu({ commit }, payload) {
      try {
        const menus = payload.menus;
        const { data } = await api.SearchMenu(payload.data);
        const result = data.result;
        for (let i = 0; i < result.length; i++) {
          const item = result[i];
          if (item.menus[0]) {
            for (let j = 0; j < item.menus.length; j++) {
              const menu = item.menus[j];
              menu.menuItemCode = menu.menu_item_code;
              menu.menuGroupCode = item.menu_group_code;
              menu.unitPrice = menu.price;
              menu.quantity = 0;
              menu.orderVariants = menu.variants;
            }
          }
        }
        if (!payload.data.search_keyword) {
          commit('SET_SEARCH_MENU', []);
          return data;
        }
        let filterData = [];
        for (let i = 0; i < result.length; i++) {
          const item = result[i];
          if (item.menus.length) {
            filterData = filterData.concat(item.menus);
          }
        }
        for (let i = 0; i < menus.length; i++) {
          const menu = menus[i];
          for (let k = 0; k < filterData.length; k++) {
            const filterMenu = filterData[k];
            if (
              (filterMenu as any).menuItemCode === menu.menuItemCode &&
              !(menu.orderVariants && menu.orderVariants.length)
            ) {
              (filterMenu as any).quantity = menu.quantity;
            }
          }
        }
        commit('SET_SEARCH_MENU', filterData);
        return data;
      } catch (e) {
        return e.response;
      }
    },

    async SetOrder({ commit }, payload) {
      try {
        const { data } = await api.SetOrder(payload);
        return data;
      } catch (e) {
        return e.response;
      }
    }
  }
};

export default store;
